module.exports = __webpack_public_path__ + "img/tasty-tuna-sandwiches.71ffc458.jpg";